import { useTranslation } from "react-i18next";
import { Filter } from "lucide-react";
import { NeuCard, NeuInput } from "../../components/neu/Neu";
import { SupplierPicker } from "./SupplierPicker";
import { NEEDS } from "./ReportChips";

// مرشّحات التقرير: تتغيّر تلقائيًا حسب التقرير المختار.
export const ReportFilters = ({ kind, filters, onChange }) => {
  const { t } = useTranslation();
  const needs = NEEDS[kind] || [];
  const set = (key) => (value) => onChange({ ...filters, [key]: value });

  return (
    <NeuCard className="grid gap-3 p-4" data-testid="report-filters">
      <div className="flex items-center gap-2 text-[11px] text-muted-foreground">
        <Filter className="h-3.5 w-3.5 text-primary" />
        <span className="font-bold">{t("purchases.reports.filters")}</span>
        <span>— {t("purchases.reports.filtersHint")}</span>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {needs.includes("from_date") ? (
          <label className="grid gap-1.5 text-[11px] font-bold text-muted-foreground">
            {t("purchases.reports.fromDate")}
            <NeuInput data-testid="report-from-date" type="date" value={filters.from_date}
                      onChange={(e) => set("from_date")(e.target.value)} />
          </label>
        ) : null}
        {needs.includes("to_date") ? (
          <label className="grid gap-1.5 text-[11px] font-bold text-muted-foreground">
            {t("purchases.reports.toDate")}
            <NeuInput data-testid="report-to-date" type="date" value={filters.to_date}
                      onChange={(e) => set("to_date")(e.target.value)} />
          </label>
        ) : null}
        {needs.includes("as_of") ? (
          <label className="grid gap-1.5 text-[11px] font-bold text-muted-foreground">
            {t("purchases.aging.asOf")}
            <NeuInput data-testid="report-as-of" type="date" value={filters.as_of}
                      onChange={(e) => set("as_of")(e.target.value)} />
          </label>
        ) : null}
        {needs.includes("supplier") ? (
          <label className="grid gap-1.5 text-[11px] font-bold text-muted-foreground">
            <span className="text-destructive">* {t("purchases.cols.supplier")}</span>
            <SupplierPicker testid="report-supplier" value={filters.supplier_id}
                            onChange={set("supplier_id")} />
          </label>
        ) : null}
      </div>
    </NeuCard>
  );
};
